export default "__VITE_ASSET__CLxcdjlk__"